import {Status} from 'constants/StatusConstants';
import {AutomationOutputFile} from 'lab-automation/automation-files/LabAutomationConstants';

import {AutomationOutputFileGraphQL} from '../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';

export default function areAllArchivableOutputFilesArchived(
  automationOutputFiles: Array<AutomationOutputFile | AutomationOutputFileGraphQL>
): boolean {
  for (const automationOutputFile of automationOutputFiles) {
    if (
      automationOutputFile.archiveRecord == null &&
      automationOutputFile.status === Status.SUCCEEDED &&
      automationOutputFile.automationOutputFileConfig.resultSchemaInfo != null
    ) {
      return false;
    }
  }
  return true;
}
